import { TaskRequirement } from '../models';
import { ModelResource } from './resource';

export class TaskRequirements extends ModelResource<TaskRequirement> {
  model = TaskRequirement;
  resourcePath = 'v1/hitl';

  async resolve(requirement: TaskRequirement, data: Record<string, any>): Promise<TaskRequirement> {
    if (data.resolution) {
      data.resolution['type'] = 'custom';
    }
    const response = await this.api.post(this.path(requirement.id, 'resolve'), { data });
    requirement.updateFromJson(response.data);
    return requirement;
  }

  async dismiss(requirement: TaskRequirement): Promise<TaskRequirement> {
    const response = await this.api.post(this.path(requirement.id, 'dismiss'));
    requirement.updateFromJson(response.data);
    return requirement;
  }

  async skip(requirement: TaskRequirement): Promise<TaskRequirement> {
    const response = await this.api.post(this.path(requirement.id, 'skip'));
    requirement.updateFromJson(response.data);
    return requirement;
  }
}
